import { WModalButton } from "@/components/button/WToolButton.tsx";
import FF from "@/components/forms/FormField.module.css";
import TF from "@/components/forms/TextField.module.css";
import { WModalForm } from "@/components/forms/WModalForm.tsx";
import { WTextField } from "@/components/forms/WTextField.tsx";
import { formPropsToAriaProps } from "@/components/forms/ariaController.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { changeObjectStorageKeyMutation } from "@/modules/storage/account/storageAccountApi.ts";
import { cn } from "@/utils/classNames.ts";
import { useLingui } from "@lingui/react/macro";
import { Input } from "react-aria-components";
import { Controller, useForm, type SubmitHandler } from "react-hook-form";

interface UpdateKeyInputs {
    description: string;
}

export interface UpdateKeyModalProps {
    storageAccountUuid: string;
    accessKey: string;
    value?: string;
}

function UpdateKeyModalContent({ storageAccountUuid, accessKey, value }: UpdateKeyModalProps) {
    //#region Hooks
    const { t } = useLingui();
    const createMutation = useStandardMutation(changeObjectStorageKeyMutation);
    //#endregion

    const onSubmit: SubmitHandler<UpdateKeyInputs> = async (inputs) => {
        const { description } = inputs;

        await createMutation.mutateAsync({
            body: {
                description,
            },
            access_key: accessKey,
            uuid: storageAccountUuid,
        });
    };

    const form = useForm<UpdateKeyInputs>({
        mode: "onBlur",
        reValidateMode: "onBlur",

        defaultValues: {
            description: value,
        },
    });

    const { control } = form;

    return (
        <WModalForm className="w-sm" form={form} onSubmit={onSubmit} title={t`Edit name`} label={t`Edit`}>
            <Controller
                control={control}
                name="description"
                render={(props) => (
                    <WTextField {...formPropsToAriaProps(props)} autoFocus headless block label={t`Key name`}>
                        <Input className={cn(FF.FormFieldInput, TF.Input)} />
                    </WTextField>
                )}
            />
        </WModalForm>
    );
}

export function UpdateKeyModal(props: UpdateKeyModalProps) {
    const { t } = useLingui();
    return (
        <WModal button={<WModalButton inTable label={t`Edit`} icon="jp-icon-edit" />}>
            <UpdateKeyModalContent {...props} />
        </WModal>
    );
}
